import { Voltage } from '../../../../../../domain/Voltage';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageDiffTransformerEndEvaluation {
  private readonly ruleName = 'Mv_EnergyConsumer_VoltageDiffTransformerEnd';

  constructor(private readonly ruleProvider: ForRuleProviding) {}

  public evaluate(voltageDiffNominal: number): EvaluationResultType<Voltage> {
    const rule = this.ruleProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      voltageDiffNominal
    );
    const value = new Voltage(voltageDiffNominal);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
